'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.createClient = exports.createHttp = undefined;

var _http = require('./http');

var _http2 = _interopRequireDefault(_http);

var _client = require('./client');

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (apiUrl, token) {
	var onPromiseResolved = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (promise) {
		return promise;
	};
	return (0, _client2.default)((0, _http2.default)(apiUrl, token, onPromiseResolved));
};

exports.createHttp = _http2.default;
exports.createClient = _client2.default;


//////////////////
// WEBPACK FOOTER
// ./~/sipgate-rest-api-client/dist/index.js
// module id = 834
// module chunks = 0